import axios from '@/axios';

export async function getReasonFamilyRefusals(reasonId, params) {
    const { data } = await axios.get(`authorization_options/all_reason_not_donation_id/${reasonId}`, { params });
    return data.data ? data.data : data;
}

export async function saveReasonFamilyRefusal(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/authorization_options/${id}` : `authorization_options`;
    return await axios({ method, url, data: data });
}
